import { Component, Inject, OnInit } from '@angular/core';
import { LocalAttractionService } from '../service/local-attraction.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditLocalAttractionComponent } from '../edit-local-attraction/edit-local-attraction.component';


@Component({
  selector: 'app-delete-local-attraction',
  templateUrl: './delete-local-attraction.component.html',
  styleUrls: ['./delete-local-attraction.component.scss']
})
export class DeleteLocalAttractionComponent implements OnInit {
  localAttractionId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditLocalAttractionComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _localAttractionService: LocalAttractionService) {
    this.localAttractionId = data.localAttractionId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._localAttractionService.deleteLocalAttraction(this.airportId, this.localAttractionId);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
